module.exports = __webpack_public_path__ + "static/media/OurStory-TanBlock.a995163a.svg";